/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC1155Handler,
  ERC1155HandlerInterface,
} from "../ERC1155Handler";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "ContractAddressNotWhitelisted",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "actual",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expected",
        type: "uint256",
      },
    ],
    name: "UnexpectedValue",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToTokenContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_tokenContractAddressToTokenProperties",
    outputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "isWhitelisted",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isBurnable",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "isSet",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "externalDecimals",
            type: "uint8",
          },
        ],
        internalType: "struct ERCHandlerHelpers.Decimals",
        name: "decimals",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "defaultDecimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "setBurnable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "executeProposal",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "args",
        type: "bytes",
      },
    ],
    name: "setResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60a060405234801561001057600080fd5b5060405161133138038061133183398101604081905261002f91610040565b6001600160a01b0316608052610070565b60006020828403121561005257600080fd5b81516001600160a01b038116811461006957600080fd5b9392505050565b60805161129f610092600039600081816101690152610633015261129f6000f3fe608060405234801561001057600080fd5b50600436106100b45760003560e01c8063ac607c2111610071578063ac607c211461018b578063b07e54bb14610220578063bc197c8114610240578063e248cff214610278578063f23a6e611461028b578063fa8675b0146102aa57600080fd5b806301ffc9a7146100b957806307b7ed99146100e15780630968f264146100f65780630a6d55d81461010957806330f08abd1461014a578063318c136e14610164575b600080fd5b6100cc6100c73660046109fd565b6102bd565b60405190151581526020015b60405180910390f35b6100f46100ef366004610a3c565b6102f4565b005b6100f4610104366004610b1e565b610308565b610132610117366004610b5b565b6000602081905290815260409020546001600160a01b031681565b6040516001600160a01b0390911681526020016100d8565b610152601281565b60405160ff90911681526020016100d8565b6101327f000000000000000000000000000000000000000000000000000000000000000081565b6101e8610199366004610a3c565b600160208181526000928352604092839020805492810154845180860190955260029091015460ff81811615158652610100918290048116938601939093529293828216939091049091169084565b6040805194855292151560208086019190915291151592840192909252815115156060840152015160ff16608082015260a0016100d8565b61023361022e366004610bbd565b610361565b6040516100d89190610c71565b61025f61024e366004610d0e565b63bc197c8160e01b95945050505050565b6040516001600160e01b031990911681526020016100d8565b610233610286366004610dbc565b610457565b61025f610299366004610e08565b63f23a6e6160e01b95945050505050565b6100f46102b8366004610bbd565b61056c565b60006001600160e01b03198216630271189760e51b14806102ee57506301ffc9a760e01b6001600160e01b03198316145b92915050565b6102fc610628565b610305816106a2565b50565b610310610628565b60008060608060608580602001905181019061032c9190610ecc565b93985091965094509250905061034a6001600160a01b038516610714565b50610359853086868686610741565b505050505050565b606061036b610628565b60608061037a84860186610fb8565b60008981526020819052604090205491935091506001600160a01b0316806103f45760405162461bcd60e51b815260206004820152602260248201527f70726f7669646564207265736f75726365494420646f6573206e6f74206578696044820152611cdd60f21b60648201526084015b60405180910390fd5b6001600160a01b03811660009081526001602081905260409091200154610100900460ff161561042f5761042a818885856107b2565b61044c565b61044c818830868660405180602001604052806000815250610741565b505050949350505050565b6060610461610628565b60608080806104728688018861101c565b81519397509195509350915061048990601461081d565b5060208281015160008a81528083526040808220546001600160a01b031680835260019485905291209092015490919060ff166104e4576040516325df77c560e11b81526001600160a01b03821660048201526024016103eb565b6001600160a01b03811660009081526001602081905260409091200154610100900460ff16156105235761051e818360601c888887610850565b610534565b61053481308460601c898988610741565b808260601c878760405160200161054e9493929190611104565b60405160208183030381529060405296505050505050509392505050565b610574610628565b61058e6001600160a01b038416636cdb3d1360e11b6108be565b6105da5760405162461bcd60e51b815260206004820152601f60248201527f746f6b656e20646f6573206e6f7420737570706f72742049455243313135350060448201526064016103eb565b60008481526020818152604080832080546001600160a01b0319166001600160a01b03881690811790915583526001918290529091208581558101805461ffff191690911790555b50505050565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146106a05760405162461bcd60e51b815260206004820152601e60248201527f73656e646572206d7573742062652062726964676520636f6e7472616374000060448201526064016103eb565b565b6001600160a01b0381166000908152600160208190526040909120015460ff166106ea576040516325df77c560e11b81526001600160a01b03821660048201526024016103eb565b6001600160a01b0316600090815260016020819052604090912001805461ff001916610100179055565b60006001600160a01b03821661073d5760405163d92e233d60e01b815260040160405180910390fd5b5090565b604051631759616b60e11b815286906001600160a01b03821690632eb2c2d690610777908990899089908990899060040161114d565b600060405180830381600087803b15801561079157600080fd5b505af11580156107a5573d6000803e3d6000fd5b5050505050505050505050565b604051631ac8311560e21b815284906001600160a01b03821690636b20c454906107e4908790879087906004016111ab565b600060405180830381600087803b1580156107fe57600080fd5b505af1158015610812573d6000803e3d6000fd5b505050505050505050565b60008183146108495760405163c230690360e01b815260048101849052602481018390526044016103eb565b5090919050565b604051630fbfeffd60e11b815285906001600160a01b03821690631f7fdffa906108849088908890889088906004016111e1565b600060405180830381600087803b15801561089e57600080fd5b505af11580156108b2573d6000803e3d6000fd5b50505050505050505050565b60006108c9836108e1565b80156108da57506108da8383610914565b9392505050565b60006108f4826301ffc9a760e01b610914565b80156102ee575061090d826001600160e01b0319610914565b1592915050565b604080516001600160e01b0319831660248083019190915282518083039091018152604490910182526020810180516001600160e01b03166301ffc9a760e01b179052905160009190829081906001600160a01b038716906175309061097b90869061122b565b6000604051808303818686fa925050503d80600081146109b7576040519150601f19603f3d011682016040523d82523d6000602084013e6109bc565b606091505b50915091506020815110156109d757600093505050506102ee565b8180156109f35750808060200190518101906109f39190611247565b9695505050505050565b600060208284031215610a0f57600080fd5b81356001600160e01b0319811681146108da57600080fd5b6001600160a01b038116811461030557600080fd5b600060208284031215610a4e57600080fd5b81356108da81610a27565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff81118282101715610a9857610a98610a59565b604052919050565b600067ffffffffffffffff821115610aba57610aba610a59565b50601f01601f191660200190565b600082601f830112610ad957600080fd5b8135610aec610ae782610aa0565b610a6f565b818152846020838601011115610b0157600080fd5b816020850160208301376000918101602001919091529392505050565b600060208284031215610b3057600080fd5b813567ffffffffffffffff811115610b4757600080fd5b610b5384828501610ac8565b949350505050565b600060208284031215610b6d57600080fd5b5035919050565b60008083601f840112610b8657600080fd5b50813567ffffffffffffffff811115610b9e57600080fd5b602083019150836020828501011115610bb657600080fd5b9250929050565b60008060008060608587031215610bd357600080fd5b843593506020850135610be581610a27565b9250604085013567ffffffffffffffff811115610c0157600080fd5b610c0d87828801610b74565b95989497509550505050565b60005b83811015610c34578181015183820152602001610c1c565b838111156106225750506000910152565b60008151808452610c5d816020860160208601610c19565b601f01601f19169290920160200192915050565b6020815260006108da6020830184610c45565b600067ffffffffffffffff821115610c9e57610c9e610a59565b5060051b60200190565b600082601f830112610cb957600080fd5b81356020610cc9610ae783610c84565b82815260059290921b84018101918181019086841115610ce857600080fd5b8286015b84811015610d035780358352918301918301610cec565b509695505050505050565b600080600080600060a08688031215610d2657600080fd5b8535610d3181610a27565b94506020860135610d4181610a27565b9350604086013567ffffffffffffffff80821115610d5e57600080fd5b610d6a89838a01610ca8565b94506060880135915080821115610d8057600080fd5b610d8c89838a01610ca8565b93506080880135915080821115610da257600080fd5b50610daf88828901610ac8565b9150509295509295909350565b600080600060408486031215610dd157600080fd5b83359250602084013567ffffffffffffffff811115610def57600080fd5b610dfb86828701610b74565b9497909650939450505050565b600080600080600060a08688031215610e2057600080fd5b8535610e2b81610a27565b94506020860135610e3b81610a27565b93506040860135925060608601359150608086013567ffffffffffffffff811115610e6557600080fd5b610daf88828901610ac8565b600082601f830112610e8257600080fd5b81516020610e92610ae783610c84565b82815260059290921b84018101918181019086841115610eb157600080fd5b8286015b84811015610d035780518352918301918301610eb5565b600080600080600060a08688031215610ee457600080fd5b8551610eef81610a27565b6020870151909550610f0081610a27565b604087015190945067ffffffffffffffff80821115610f1e57600080fd5b610f2a89838a01610e71565b94506060880151915080821115610f4057600080fd5b610f4c89838a01610e71565b93506080880151915080821115610f6257600080fd5b508601601f81018813610f7457600080fd5b8051610f82610ae782610aa0565b818152896020838501011115610f9757600080fd5b610fa8826020830160208601610c19565b8093505050509295509295909350565b60008060408385031215610fcb57600080fd5b823567ffffffffffffffff80821115610fe357600080fd5b610fef86838701610ca8565b9350602085013591508082111561100557600080fd5b5061101285828601610ca8565b9150509250929050565b6000806000806080858703121561103257600080fd5b843567ffffffffffffffff8082111561104a57600080fd5b61105688838901610ca8565b9550602087013591508082111561106c57600080fd5b61107888838901610ca8565b9450604087013591508082111561108e57600080fd5b61109a88838901610ac8565b935060608701359150808211156110b057600080fd5b506110bd87828801610ac8565b91505092959194509250565b600081518084526020808501945080840160005b838110156110f9578151875295820195908201906001016110dd565b509495945050505050565b6001600160a01b03858116825284166020820152608060408201819052600090611130908301856110c9565b828103606084015261114281856110c9565b979650505050505050565b6001600160a01b0386811682528516602082015260a060408201819052600090611179908301866110c9565b828103606084015261118b81866110c9565b9050828103608084015261119f8185610c45565b98975050505050505050565b6001600160a01b03841681526060602082018190526000906111cf908301856110c9565b82810360408401526109f381856110c9565b6001600160a01b0385168152608060208201819052600090611205908301866110c9565b828103604084015261121781866110c9565b905082810360608401526111428185610c45565b6000825161123d818460208701610c19565b9190910192915050565b60006020828403121561125957600080fd5b815180151581146108da57600080fdfea2646970667358221220b2b8a27ec4ec5a80267933354ff19492921af3edc3086549939805f92054a12d64736f6c634300080b0033";

type ERC1155HandlerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC1155HandlerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC1155Handler__factory extends ContractFactory {
  constructor(...args: ERC1155HandlerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ERC1155Handler";
  }

  deploy(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC1155Handler> {
    return super.deploy(
      bridgeAddress,
      overrides || {}
    ) as Promise<ERC1155Handler>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(bridgeAddress, overrides || {});
  }
  attach(address: string): ERC1155Handler {
    return super.attach(address) as ERC1155Handler;
  }
  connect(signer: Signer): ERC1155Handler__factory {
    return super.connect(signer) as ERC1155Handler__factory;
  }
  static readonly contractName: "ERC1155Handler";
  public readonly contractName: "ERC1155Handler";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC1155HandlerInterface {
    return new utils.Interface(_abi) as ERC1155HandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC1155Handler {
    return new Contract(address, _abi, signerOrProvider) as ERC1155Handler;
  }
}
